import { useQuery } from '@tanstack/react-query';
import type { AiVisibilityReportsPageResponse } from '@brand24-original/llm-types';
import { getAiVisibilityReports } from '../../services/ai-visibility-report/AiVisibilityReportService';
import { GET_AI_VISIBILITY_REPORTS } from '../../query/ai-visibility-report/keys';

export const useGetAiVisibilityReports = (
  projectId: number | null,
  page: number,
  pageSize: number
) => {
  return useQuery<AiVisibilityReportsPageResponse>({
    queryKey: [GET_AI_VISIBILITY_REPORTS, projectId, page, pageSize],
    queryFn: () => getAiVisibilityReports(projectId!, page, pageSize),
    enabled: projectId != null,
    staleTime: 5_000,
    refetchOnWindowFocus: false,
  });
};
